import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { fromZodError } from 'zod-validation-error'

import { client } from '../services/client'
import { QueryContextFromKeys } from '../utils/react-query'
import { makeServerResponseSchema } from '../utils/schema'

type EmbeddableQueryKeys = QueryContextFromKeys<typeof embeddableQueryKeys>

const embeddableQueryKeys = {
  all: [{ entity: 'embeddable' }] as const,
  embeddableId: (embeddableId: string) => [
    { ...embeddableQueryKeys.all[0], embeddableId },
  ],
}

const embeddableKeySchema = z.object({ token: z.string() })

async function fetchEmbeddable({ embeddableId }: { embeddableId: string }) {
  const response = await client
    .post('functions/embeddableKey', { json: { embeddableId } })
    .json()

  const parsedResponse =
    makeServerResponseSchema(embeddableKeySchema).safeParse(response)

  if (!parsedResponse.success)
    throw new Error(fromZodError(parsedResponse.error).message)

  return parsedResponse.data.result.token
}

function useEmbeddable(
  embeddableId: Parameters<typeof embeddableQueryKeys['embeddableId']>[0]
) {
  return useQuery({
    queryKey: embeddableQueryKeys.embeddableId(embeddableId),
    queryFn: () => fetchEmbeddable({ embeddableId }),
  })
}

export type { EmbeddableQueryKeys }
export { useEmbeddable }
